export function toProxyUrl(url) {
    if (!url) return url;
    // Leave blob/data/preview URLs unchanged (local previews during editing)
    if (url.startsWith("blob:") || url.startsWith("data:") || url === "preview") return url;
    // Transform Firebase Storage URLs → /media/folder/filename (real slash, no %2F)
    const match = url.match(/firebasestorage\.googleapis\.com\/v0\/b\/[^/]+\/o\/([^?]+)/);
    if (!match) return url;
    // Decode %2F → real / so nginx location regex can split on folder/file boundary
    const path = decodeURIComponent(match[1]); // e.g. "banners/rahulsingh_1778473164716"
    return `/media/${path}`;
}
